import { Spinner } from "@msuite/ui/spinner";
import type { AnswerResult } from "@msuite/utils/types";
import { motion } from "motion/react";

/** Props Interface */
interface InsightsSpotlightAnswerProps {
	item: AnswerResult;
}

export function InsightsSpotlightAnswer({ item }: InsightsSpotlightAnswerProps) {
	/** Render */
	return (
		<motion.div className="card w-2/3 self-start rounded-xl px-5 py-4 text-lg bg-primary-800 **:text-white! border-primary-900">
			{item.summary.length > 0 ? (
				<p>{item.summary}</p>
			) : (
				<div className="h-stack">
					<Spinner />
					<p>Thinking...</p>
				</div>
			)}
		</motion.div>
	);
}
